import React, {FC} from "react";
import {SeoProps} from "@components/entities/seo/types";
import Head from "next/head";
import {buildTags} from "@components/entities/seo/buildTags";

interface ISEO {
    config: SeoProps;
}

const SEO: FC<ISEO> = ({config}) => {
    const {title, description} = config;

    return (
        <Head>
            {buildTags({
                title,
                description
            })}
        </Head>
    );
};

export default SEO;
